import { useEffect, useState } from "react";
import api from "@/lib/api";

const KEY = "brand_slogan";
const DEFAULT = "Apprendre · Comprendre · Pratiquer";
let pending = null;

// Slogan under the logo, editable in admin settings; cached so the header never flickers.
export function useBrandSlogan() {
    const [slogan, setSlogan] = useState(() => localStorage.getItem(KEY) || DEFAULT);
    useEffect(() => {
        pending ||= api.get("/settings/public").then((r) => r.data.brand_slogan || DEFAULT).catch(() => null);
        pending.then((s) => {
            if (!s) return;
            localStorage.setItem(KEY, s);
            setSlogan(s);
        });
    }, []);
    return slogan;
}

export function refreshBrandSlogan(s) {
    localStorage.setItem(KEY, s || DEFAULT);
    pending = Promise.resolve(s || DEFAULT);
}
